/**
 * Website-identity cache slice (formerly the legacy `companies` slice).
 *
 * After the company-model decommission refactor this slice no longer mirrors
 * a local CompanyModel — it just holds the response of `getCompany(id)` /
 * `getCompanyPublicDetails(id)`, both of which proxy through the website
 * backend's `/Companies/:id/public` endpoint (cached in `companyValidator`).
 *
 * Identity fields (businessName, vatRecord, commercialRecord, address, etc.)
 * are read from here. Tenant-local operational fields (logo, FooterText,
 * DefaultInvoiceNote, ZATCA, currency, vatPercentage, etc.) come from
 * `state.companyProfile.profile` instead — components merge the two when both
 * are needed.
 *
 * The legacy CREATE / UPDATE / DELETE / FETCH_COMPANIES action paths were
 * removed in Phase 3; the only writers left are the two read thunks above.
 * The slice is kept rather than renamed to avoid churning the 13+ component
 * call sites that select from `state.companies.company`.
 */

import {
  START_LOADING,
  END_LOADING,
  FETCH_COMPANY,
  FETCH_COMPANY_PUBLIC_DETAILS,
} from "../actions/constants";

const companies = (state = { isLoading: false, company: null }, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };
    case END_LOADING:
      return { ...state, isLoading: false };
    case FETCH_COMPANY_PUBLIC_DETAILS:
      return { ...state, company: action.payload };
    case FETCH_COMPANY:
      return { ...state, company: action.payload };
    default:
      return state;
  }
};

export default companies;
